import { useTranslation } from "@refinedev/core";

import { ConfirmDialog } from "./confirm-dialog";

interface ConfirmDeleteDialogProps {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDeleteDialog = ({ open, message, onConfirm, onCancel }: ConfirmDeleteDialogProps) => {
  const { translate } = useTranslation();

  return (
    <ConfirmDialog
      open={open}
      title={translate("common.confirmDeleteTitle")}
      message={message}
      confirmLabel={translate("buttons.delete")}
      confirmColor="error"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
